<template>
  <div class="app-container">
    <el-button
      class="go-back"
      size="small"
      type="primary"
      @click.stop="goBack()"
    >
      返回
    </el-button>

    <el-tabs v-model="activeIndex" type="border-card" @tab-click="handleClick">
      <!-- 视频详情 -->
      <el-tab-pane
        v-for="tab in tabList"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      >
        <!-- <keep-alive>
          <component
            v-if="tab.name === activeIndex"
            :is="tab.name"
            :videoID="$route.query.videoID"
          ></component>
        </keep-alive> -->

      <keep-alive>
        <component
          :is="activeIndex"
          :videoID="$route.query.videoID"
        ></component>
      </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VideoDetail from "./videoDetail.vue";
import VideoComment from "./videoComment.vue";
import LikeUsers from "./likeUsers.vue";

export default {
  components: {
    VideoDetail,
    VideoComment,
    LikeUsers,
  },
  data() {
    return {
      activeIndex: "VideoDetail", // 当前索引
      // searchValue: "", // 搜索内容
      // totalCount: 0, // 列表总数
      // pageSize: 10, // 单页条数
      // currentPage: 1, // 当前页码
      // videoID: "", // 视频ID
      // videoForm: {}, // 视频详情表单
      // imageUrl: "",
      // videoCommentList: [], // 视频评论列表
      // replyVideoCommentListDialog: false, // 视频评论回复列表开关
      // replyVideoCommentList: [], // 视频评论回复列表
      // videoLikeUserList: [], // 视频点赞用户列表

      tabList: [
        { name: "VideoDetail", label: "视频详情" },
        { name: "VideoComment", label: "视频评论" },
        { name: "LikeUsers", label: "点赞用户" },
      ],
    };
  },
  // computed: {
  //   // 内部员工无需选择系列
  //   isNeedToPay: function () {
  //     if (this.videoForm.payStatus === 1) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   },
  // },
  // created() {
  //   this.videoID = this.$route.query.videoID;
  // },
  methods: {
    /**
     *
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 切换 tab
     *
     * @param tab 当前标签
     */
    handleClick(tab) {
      this.currentPage = 1;
      console.log(tab, this.activeIndex);
      // switch (tab.name) {
      //   case "0":
      //     this.getOne();
      //     break;
      //   case "1":
      //     this.getVideoCommentList();
      //     break;
      //   case "2":
      //     this.getVideoLikeUserList();
      //     break;
      // }
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    // currentChange(currentPage) {
    //   this.currentPage = currentPage;
    //   switch (this.activeIndex) {
    //     case "1":
    //       this.getVideoCommentList();
    //       break;
    //     case "2":
    //       this.getVideoLikeUserList();
    //       break;
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
